import { QueryClient } from 'react-query';

let toastInstance: any = null;

export const setToastInstance = (toast: any) => {
  toastInstance = toast;
};

const handleQueryError = (error: any) => {
  if (!toastInstance) {
    console.error('Toast not initialized:', error);
    return;
  }

  // The /geo module handles its own toasts via ToastV2 inside each component.
  // Suppress the global v1 toast to avoid duplicate notifications.
  const requestUrl: string =
    error?.requestUrl ?? error?.config?.url ?? error?.response?.config?.url ?? '';
  if (requestUrl.includes('/api/v1/geo/')) {
    return;
  }

  const status = error?.response?.status;
  const errorDetail = error?.response?.data?.detail;
  const errorMessage = error?.response?.data?.message;

  let message: string | string[] = 'Ocorreu um erro inesperado, tente novamente mais tarde!';

  if (status === 401) {
    message = 'Sua sessão expirou. Faça login novamente.';
  } else if (status === 403) {
    message = 'Você não tem permissão para realizar esta ação.';
  } else if (status === 404) {
    message = 'Recurso não encontrado.';
  } else if (status >= 500) {
    message = 'Erro no servidor. Tente novamente mais tarde.';
  } else if (errorDetail) {
    message = typeof errorDetail === 'object' ? errorDetail : errorDetail;
  } else if (errorMessage) {
    message = errorMessage;
  } else if (error?.message) {
    message = error.message;
  }

  toastInstance.error(message);
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      onError: handleQueryError,
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
    mutations: {
      onError: handleQueryError,
      retry: false,
    },
  },
});
